import { Pipe, PipeTransform } from '@angular/core';
import {
  enumNumber,
  ProjectJobStatus,
  ProjectJobStatusJson,
  ProjectJobStatusSchema,
} from '@vmspdb/definitions';

@Pipe({
  name: 'enumProjectJobStatusColor',
  standalone: false,
})
export class EnumProjectJobStatusColorPipe implements PipeTransform {
  transform(value?: ProjectJobStatus | ProjectJobStatusJson): string {
    if (!value) {
      return '';
    }

    switch (enumNumber(ProjectJobStatusSchema, value)) {
      case ProjectJobStatus.ARCHIVED:
        return 'status-archived';
      case ProjectJobStatus.BILLED:
        return 'status-billed';
      case ProjectJobStatus.BILLING_REQUESTED:
        return 'status-billing-requested';
    }

    return '';
  }
}
